$(function() {

  $('.product-item--prompt').click(function(e) {
    e.preventDefault();
    if (!$(this).hasClass('selected')) {
      $('.product-item--prompt').removeClass('selected');
    }
    $(this).toggleClass('selected');
    if ($('.product-item--prompt.selected').length > 0) {
      $('.product-prompt--cta').removeClass('button--disabled');
    } else {
      $('.product-prompt--cta').addClass('button--disabled');
    }
  });

  // carousel

  var cell = isMobile ? '.prompt-carousel__item' : '.prompt-carousel__block';

  $('.prompt-carousel').flickity({
    cellSelector: cell,
    arrowShape: arrowShape,
    cellAlign: "left",
    pageDots: false
  });


});
